"use strict";
exports.__esModule = true;
exports.useCommonField = void 0;
var formik_1 = require("formik");
function useCommonField(name) {
    var _a = formik_1.useField(name), field = _a[0], meta = _a[1], helpers = _a[2];
    var isValid = meta.touched && !meta.error;
    var isInvalid = meta.touched && !!meta.error;
    var hasFeedback = meta.touched && !!meta.error;
    var flags = { isValid: isValid, isInvalid: isInvalid, hasFeedback: hasFeedback };
    return [field, meta, helpers, flags];
}
exports.useCommonField = useCommonField;
//# sourceMappingURL=useCommonField.js.map